import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SOLD_CONTENT_TYPES } from '../../constants';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import truncateHtml from '../../utils/truncateHtml';
import {get} from 'lodash';

const AUTHOR_MAX_LENGTH = 20;
const TITLE_MAX_LENGTH = 68;

const paidContentLabel = () => (
  <div className="section">
    <RosettaFormattedMessage parentFilename={__filename}
      id="paid_content_label"
      description="Label that appears on paid content standard cards"
      defaultMessage="Paid Content"
    />
  </div>
);

const contentCategoryLabel = (__html) =>
  <div className="section" dangerouslySetInnerHTML={{ __html }} />;

export default class StandardCardElements extends Component {
  shouldComponentUpdate = (nextProps) =>
    this.props.cardID !== nextProps.cardID;

  authorLabel = (name) => (
    <div className="author">
      <RosettaFormattedMessage parentFilename={__filename}
        id="byline"
        description="Author label that appears on standard cards"
        defaultMessage="by {name}"
        values={{
          name: (
            <span className="author-name"
              dangerouslySetInnerHTML={{ __html: name }}
            />
          )
        }}
      />
    </div>
  );

  author = () =>
    this.authorLabel(truncateHtml(this.authorName(), {
      length: AUTHOR_MAX_LENGTH,
      omission: '...'
    }))

  title = () =>
    truncateHtml(get(this.props, 'truncated_title_80'), {
      length: TITLE_MAX_LENGTH,
      omission: '...'
    })

  authorName = () =>
    get(this.props, 'contributors[0].display_name');

  iconType() {
    if (this.props.isVideoCard) {
      return 'video';
    } else if (this.props.type === 'SLIDESHOW') {
      return 'slideshow';
    }
    return 'article';
  }

  label = () =>
    this.props.meta.sold_content_type === SOLD_CONTENT_TYPES.CUSTOM
      ? paidContentLabel()
      : contentCategoryLabel(this.props.label)

  render() {
    const { excerpt_truncated_155 } = this.props;

    return (
      <div className="story-content">
        {this.label()}
        <div className="title">
          <span dangerouslySetInnerHTML={{ __html: this.title() }} />
        </div>
        <div className="abstract"
          dangerouslySetInnerHTML={{ __html: excerpt_truncated_155 }}
        />
        <div className="story-meta">
          {this.props.isVideoCard &&
            <figure className={`type icon-${this.iconType()}`} />
          }
          {this.author()}
        </div>
      </div>
    );
  }
}

StandardCardElements.propTypes = {
  cardID: PropTypes.number.isRequired,
  contributors: PropTypes.arrayOf(PropTypes.shape({
    display_name: PropTypes.string
  })).isRequired,
  excerpt_truncated_155: PropTypes.string.isRequired,
  isVideoCard: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    sold_content_type: PropTypes.string
  }),
  truncated_title_80: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

StandardCardElements.defaultProps = {
  contributors: [{}],
  excerpt_truncated_155: '',
  label: '',
  truncated_title_80: '',
  type: ''
};
